import { Banner } from 'component/Banner/Banner'
import { Button } from 'component/Button'
import { Radio } from 'component/Radio'
import { Space } from 'component/Space'
import { TextArea } from 'component/TextArea'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { AbuseCode, getAbuseCodeLabel } from 'type/Abuse'

type Props = {
  code: AbuseCode
}

const Check = observer(({ code }: Props) => {
  const feedback = store.carousel.feedback!
  const checked = feedback.checked(code)
  const text = getAbuseCodeLabel(code)

  const onChange = useLatestCallback(() => {
    feedback.toggle(code)
  })

  return <Radio checked={checked} onChange={onChange}>
    {text}
  </Radio>
})

const Content = observer(() => {
  const feedback = store.carousel.feedback!

  const limit = 256
  const left = limit - feedback.text.length

  const onText = useLatestCallback((value: string) => {
    feedback.text_raw = value
  })

  const onConfirm = useLatestCallback(() => {
    feedback.send()
    store.carousel.showMessage(i18n('ThanksForYourFeedback'))
    store.carousel.feedback = undefined
  })

  return <Vertical gap={16}>
    <Typo size={13} secondary>
      {i18n('LeaveYourFeedbackSoThatWeCanImproveQualityOfImageGeneration')}
    </Typo>
    <Vertical gap={4}>
      <Check code={AbuseCode.NO_SIMILARITY} />
      <Check code={AbuseCode.BAD_PROPORTIONS} />
      <Check code={AbuseCode.NOT_FIT} />
      <Check code={AbuseCode.BAD_ITEM} />
    </Vertical>
    {opt.options.likes?.feedback && <Space>
      <TextArea value={feedback.text_raw} onChange={onText} limit={limit} />
      <Space pin={[null, 12, 4, null]}>
        <Typo size={12} secondary>
          {i18n('text.CountCharactersLeft', { count: left })}
        </Typo>
      </Space>
    </Space>}
    <Button large primary disabled={!feedback.canSend} action={onConfirm}>
      {i18n('Confirm')}
    </Button>
  </Vertical>
})

export const FeedbackBanner = observer(() => {
  const inference = store.fullscreen?.inferences?.item ?? store.carousel?.carousel.item
  const open = store.carousel?.feedback

  const onCancel = useLatestCallback(async () => {
    store.carousel.feedback = undefined
  })

  if (!inference || !open) return null

  return <Banner title={i18n('GiveFeedback')} onCancel={onCancel}>
    <Content />
  </Banner>
})
